<!-- ----------------------------------------------- -->
<template>
  <div class="legend-content">
    <v-container style="align-items:center">
      <v-row class="no-gutters">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.qwtrOver" style="height: 30px;" />
        </v-col>
        <v-col :cols="8">
          <span class="location-text pl-2">
            {{ text.qwtrOver }}
          </span>
        </v-col>
      </v-row>
      <v-row class="no-gutters">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.qwtrNormal" style="height: 30px;" />
        </v-col>
        <v-col :cols="8">
          <span class="location-text pl-2">
            {{ text.qwtrNormal }}
          </span>
        </v-col>
      </v-row>
      <v-row class="no-gutters">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.qwtrTysctNone" style="height: 30px;" />
        </v-col>
        <v-col :cols="8">
          <span class="location-text pl-2">
            {{ text.qwtrTysctNone }}
          </span>
        </v-col>
      </v-row>
      <v-row class="no-gutters">
        <v-col :cols="3" class="location-img">
          <img :src="imgResource.qwtrMissing" style="height: 30px;" />
        </v-col>
        <v-col :cols="8">
          <span class="location-text pl-2">
            {{ text.qwtrMissing }}
          </span>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<!-- ----------------------------------------------- -->
<script>

/**
 * 川の防災情報 地図画面 地図凡例ダイアログ 水質
 * LegendTmQwtr.vue
 * @author LIS
 */
export default {
  name: "legend-tm-qwtr",
  data() {
    return {
      /** アイコン */
      imgResource: {
        qwtrOver: "/kawabou/img/map_icons/obs_quality_excess.svg",
        qwtrNormal: "/kawabou/img/map_icons/obs_quality_normal.svg",
        qwtrTysctNone: "/kawabou/img/map_icons/obs_quality_notset.svg",
        qwtrMissing: "/kawabou/img/map_icons/obs_quality_missing.svg",
      },
      /** 文字列リソース */
      text: {
        qwtrOver: "基準値超過",
        qwtrNormal: "平常",
        qwtrTysctNone: "類型指定なし",
        qwtrMissing: "欠測",
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.legend-content {
  width: 220px;
  .location-img {
    display: flex;
    justify-content: flex-end;
    position: relative;
    .badge {
      // position: absolute;
      top: -3px;
      right: 0px;
    }
  }
  .location-text {
    font-size: 0.9rem;
    color: black;
  }
}
</style>